import { isNil } from '@flowio/is'; // Returns groups for protocol (2), domain (3) and port (4)

var reURI = /^((http.?:)\/\/([^:/\s]+)(:\d+)*)/;
/**
 * Returns a string containing the scheme, domain, and if present the port for
 * the specified URL.
 */

export default function getLocation(url) {
  if (/^file/.test(url)) {
    throw new Error('The file:// protocol is not supported');
  }

  var matches = reURI.exec(url.toLowerCase());

  if (isNil(matches)) {
    return '';
  }

  var protocol = matches[2];
  var domain = matches[3];
  var port = matches[4] || '';

  if (isNil(protocol) || isNil(domain)) {
    return '';
  }

  if (protocol === 'http:' && port === ':80' || protocol === 'https:' && port === ':443') {
    return "".concat(protocol, "//").concat(domain);
  }

  return "".concat(protocol, "//").concat(domain).concat(port);
}


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/lib/esm/getLocation.js
// module id = 322
// module chunks = 0 1